import { render } from "./RenduMobile.vue?vue&type=template&id=86cc7888"
import script from "./RenduMobile.vue?vue&type=script&lang=js"
export * from "./RenduMobile.vue?vue&type=script&lang=js"

import "./RenduMobile.vue?vue&type=style&index=0&id=86cc7888&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__